import request from '@/utils/request'

// 获取所有的菜单树
export function getTree() {
  return request({
    url: 'api/trees',
    method: 'get'
  })
}

export function asideTree() {
  return request({
    url: 'api/trees/trees',
    method: 'get'
  })
}


export function treesByStatus(data) {
  return request({
    url: 'api/trees/getUserTreeByStatus?treeid='+data,
    method: 'get'
  })
}

export function chaptertreesByStatus(data) {
  return request({
    url: 'api/getUserChapterTreesByStatus?treeid='+data,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/trees.js